import { SocketContext } from '@/context/socket-context/external-socket-context.tsx';
import { useContext } from 'react';

/**
 * Used for tpresence everywhere
 */
export const useSocket = () => {
  return useContext(SocketContext);
};
